import { useQuery } from '@tanstack/react-query';

// constant
import { BaseError } from '../../helpers/BaseError';

// models
import { CompoundTriggerCatalog } from './../../models/compound-trigger.model';

// services
import API from '../../services/api';

const getCompoundTriggers = async () => {
    const { data } = await API.getCompoundTriggers();
    return data as CompoundTriggerCatalog[];
};

export default function useCompoundTriggers() {
    return useQuery<CompoundTriggerCatalog[], BaseError>({
        queryKey: ['compound_triggers'],
        queryFn: () => getCompoundTriggers(),
    });
}
